import React from "react";
import { Typography, Chip } from "@mui/material";
import CustomTable from "../../components/Table/Table";
import { useAllResourceSkillsViewModel } from "./AllResourceSkillsViewModel";
import AddResourceSkill from "./AddResourceSkill";
import WorkIcon from "@mui/icons-material/Work";
import { useLoading } from "../../contexts/LoadingContext";
import Modal from "../../components/Modal/Modal";
import ConfirmationModal from "../../components/ConfirmationModal/ConfirmationModal";
import { useRbac } from "../../hooks/RbacContext";


const AllResourceSkills = () => {
  const {
    isAddSkillOpen,
    selectedSkillMapping,
    successModal,
    deleteConfirmation,
    loading,
    error,
    resourceSkillMappings,
    resources,
    skills,
    handleAddSkill,
    handleEditSkill,
    handleCloseDialog,
    handleSubmit,
    setSuccessModal,
    setDeleteConfirmation,
    handleDeleteClick,
    handleDeleteConfirm,
    getActions,
    getResourceName,
    getSkillName,
    columns,
    columnFilters,
    fixedColumns,
  } = useAllResourceSkillsViewModel();

  const { showLoading, hideLoading } = useLoading();
  const {checkAccess} = useRbac();

  if (error) {
    return <Typography color="error">Error: {error}</Typography>;
  }

  return (
    <div>
      <CustomTable
        columns={columns}
        data={resourceSkillMappings}
        loading={loading}
        onAdd={handleAddSkill}
        showActions={true}
        showAddButton={checkAccess("resourceSkillMapping","add")}
        addButtonIcon={<WorkIcon />}
        showSearch={true}
        showColumnVisibility={false}
        pageSize={10}
        stickyHeader={true}
        fixedColumns={fixedColumns}
        actions={getActions}
        title="Resource Skills"
        subtitle="Manage resource skills and proficiency levels"
        addButtonText="Add Resource Skill"
        alignment="left"
        fontSize="12px"
        showFilters={true}
        columnFilters={columnFilters}
      />

      <AddResourceSkill
        open={isAddSkillOpen}
        onClose={handleCloseDialog}
        initialData={selectedSkillMapping}
        onSubmit={handleSubmit}
        resources={resources}
        skills={skills}
      />

      {successModal && (
        <Modal
          type={successModal.type}
          title={successModal.title}
          message={successModal.message}
          onClose={() => setSuccessModal(null)}
        />
      )}

      {deleteConfirmation && (
        <ConfirmationModal
          open={true}
          title="Delete Resource Skill"
          message={`Are you sure you want to delete this resource skill mapping?`}
          onClose={() => setDeleteConfirmation(null)}
          onConfirm={handleDeleteConfirm}
        />
      )}
    </div>
  );
};

export default AllResourceSkills; 